"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Node_1 = require("./types/Node");
const combinator_1 = require("./combinator");
const parseBold = combinator_1.explicit(combinator_1.regexp(/^\*(\S([^*\n]*?|[^*\n]*? `.*?` )\S|\S)\*(?=[\s.,\])}!?\-=]|$)/, (match, text, position, parseText) => {
    const [matchedText, content] = match;
    return [
        {
            type: Node_1.NodeType.Bold,
            children: parseText(content)
        },
        position + matchedText.length
    ];
}));
const parseCode = combinator_1.explicit(combinator_1.regexp(/^`([^`]+?)`(?=[\s.,\])}!?\-=]|$)/, (match, text, position) => {
    const [matchedText, content] = match;
    return [
        {
            type: Node_1.NodeType.Code,
            text: content
        },
        position + matchedText.length
    ];
}));
const parsePreText = combinator_1.explicit(combinator_1.regexp(/^```(\s*\S[\s\S]*?\s*)```(?=[\s.,\])}!?\-=]|$)/, (match, text, position) => {
    const [matchedText, content] = match;
    return [
        {
            type: Node_1.NodeType.PreText,
            text: content
        },
        position + matchedText.length
    ];
}));
const parseItalic = combinator_1.explicit(combinator_1.regexp(/^_(\S([^_\n]*?|[^_\n]*? `.*?` )\S|\S)\_(?=[\s.,\])}!?\-=]|$)/, (match, text, position, parseText) => {
    const [matchedText, content] = match;
    return [
        {
            type: Node_1.NodeType.Italic,
            children: parseText(content)
        },
        position + matchedText.length
    ];
}));
const parseStrike = combinator_1.explicit(combinator_1.regexp(/^~(\S([^~\n]*?|[^~\n]*? `.*?` )\S|\S)\~(?=[\s.,\])}!?\-=]|$)/, (match, text, position, parseText) => {
    const [matchedText, content] = match;
    return [
        {
            type: Node_1.NodeType.Strike,
            children: parseText(content)
        },
        position + matchedText.length
    ];
}));
const parseSingleLineQuote = combinator_1.topOfLine(combinator_1.regexp(/^&gt;(.*)(\n|$)/, (match, text, position, parseText) => {
    const [matchedText, content] = match;
    const repeatedGt = content.match(/^((&gt;)+)(.*)$/);
    return [
        {
            type: Node_1.NodeType.Quote,
            children: repeatedGt
                ? [
                    {
                        type: Node_1.NodeType.Text,
                        text: repeatedGt[1]
                    },
                    ...parseText(repeatedGt[3])
                ]
                : parseText(content)
        },
        position + matchedText.length
    ];
}));
const parseMultilineQuote = combinator_1.topOfLine(combinator_1.regexp(/^&gt;&gt;&gt;([\s\S]+)$/, (match, text, position, parseText) => {
    const [matchedText, content] = match;
    return [
        {
            type: Node_1.NodeType.Quote,
            children: parseText(content)
        },
        position + matchedText.length
    ];
}));
const parseEmoji = combinator_1.regexp(/^:([^:<`*#@!\s]+):(:(skin-tone-.+?):)?/, (match, text, position) => {
    const [matchedText, name, _, variation] = match;
    return [
        {
            type: Node_1.NodeType.Emoji,
            name,
            variation
        },
        position + matchedText.length
    ];
});
const parseLink = combinator_1.regexp(/^<([^\s<>][^\n<>]*?)(\|([^<>]+?))?>/, (match, text, position, parseText) => {
    const [matchedText, link, _, label] = match;
    const nextPosition = position + matchedText.length;
    const labelNodes = label ? parseText(label) : undefined;
    switch (link.charAt(0)) {
        case '@':
            return [
                {
                    type: Node_1.NodeType.UserLink,
                    userID: link.slice(1),
                    label: labelNodes
                },
                nextPosition
            ];
        case '#':
            return [
                {
                    type: Node_1.NodeType.ChannelLink,
                    channelID: link.slice(1),
                    label: labelNodes
                },
                nextPosition
            ];
        case '!':
            const [commandName, ...args] = link.slice(1).split('^');
            return [
                {
                    type: Node_1.NodeType.Command,
                    name: commandName,
                    arguments: args,
                    label: labelNodes
                },
                nextPosition
            ];
        default:
            return [
                {
                    type: Node_1.NodeType.URL,
                    url: link,
                    label: labelNodes
                },
                nextPosition
            ];
    }
});
exports.default = combinator_1.or([
    parseBold,
    parsePreText,
    parseCode,
    parseEmoji,
    parseItalic,
    parseMultilineQuote,
    parseSingleLineQuote,
    parseLink,
    parseStrike
]);
//# sourceMappingURL=parser.js.map